import React, { FC } from 'react';
import MuiRadio, { RadioProps as MuiRadioProps } from '@material-ui/core/Radio';
import { Uds } from '../../types';

export type RadioProps = Uds<MuiRadioProps & {}>;

export const Radio: FC<React.PropsWithChildren<RadioProps>> = ({ dataTest, ...props }) => (
  <MuiRadio data-test={dataTest} {...props} />
);
